<template>
  <div class="PersCent">
    <div class="PersCent-background">
      <div class="PersCent-PersInfo">
        <div class="PersCent-PersInfo-Navition">
          <router-link :to="{path: 'MessCent'}">
            <img src="../../public/obraoag/PersNotice.png" alt="">
          </router-link>
          <router-link :to="{path: 'setup'}">
            <img src="../../public/obraoag/PersSetUp.png" alt="">
          </router-link>
        </div>
        <div class="PersCent-background-HeadPort">
          <img src="../../public/obraoag/PersHeadPort.png" alt="">
        </div>
        <div class="PersCent-background-Telephone">{{persbant}}</div>
      </div>
      <div class="PersCent-category">
        <router-link :to="{path: 'CardBag',query: {HoCardBag: '1'}}">
          <div class="PersCent-category-fill PersCent-category-HoriLine">
            <p class="PersCent-category-fill-bill">账单</p>
          </div>
        </router-link>
        <router-link :to="{path: 'SelectCard',query: {HoSelect: '2',persalge: '1'}}">
          <div class="PersCent-category-fill PersCent-category-HoriLine">
            <p class="PersCent-category-fill-balance">余额</p>
          </div>
        </router-link>
        <router-link :to="{path: 'SelectCard',query: {HoSelect: '3',persalge: '1'}}">
          <div class="PersCent-category-fill">
            <p class="PersCent-category-fill-integral">积分</p>
          </div>
        </router-link>
      </div>
      <div class="PersCent-category">
        <router-link :to="{path: 'CardBag',query: {HoCardBag: '0'}}">
          <div class="PersCent-category-fill PersCent-category-HoriLine">
            <p class="PersCent-category-fill-CardBag">卡包</p>
          </div>
        </router-link>
        <router-link :to="{path: 'restpard'}">
          <div class="PersCent-category-fill PersCent-category-HoriLine">
            <p class="PersCent-category-fill-BankCard">银行卡</p>
          </div>
        </router-link>
        <router-link :to="{path: 'register',query: {siyzstate: '14',servmope: '2'}}">
          <div class="PersCent-category-fill PersCent-category-HoriLine">
            <p class="PersCent-category-fill-modify">支付密码修改</p>
          </div>
        </router-link>
        <router-link :to="{path: 'MessCent', query: {servhelp: '0'}}">
          <div class="PersCent-category-fill PersCent-category-HoriLine">
            <p class="PersCent-category-fill-help">帮助中心</p>
          </div>
        </router-link>
        <router-link :to="{path: 'privolcy'}">
          <div class="PersCent-category-fill PersCent-category-HoriLine">
            <p class="PersCent-category-fill-vacy">隐私政策</p>
          </div>
        </router-link>
        <router-link :to="{path: 'userment'}">
          <div class="PersCent-category-fill">
            <p class="PersCent-category-fill-agnt">用户协议</p>
          </div>
        </router-link>
      </div>
      <!-- 底部导航 -->
      <div class="PersCent-Navition">
        <router-link :to="{path: '/'}">
          <div class="PersCent-Navition-content PersCent-Navition-hoge">
            <img src="../../public/obraoag/HomePage.png" alt="">
            <span>首页</span>
          </div>
        </router-link>
        <router-link :to="{path: 'outlets'}">
          <div class="PersCent-Navition-content PersCent-Navition-cork">
            <img src="../../public/obraoag/HomeFind.png" alt="">
            <span>商业网点</span>
          </div>
        </router-link>
        <div class="PersCent-Navition-content PersCent-Navition-size">
          <img src="../../public/obraoag/HomeMySelect.png" alt="">
          <span>我的</span>
        </div>
      </div>
    </div>
    <!-- 失败提示 -->
    <div id="warnToast" :style="'display:' + persfail">
      <div class="weui-mask_transparent"></div>
      <div class="weui-toast">
        <i class="weui-icon-warn weui-icon_toast"></i>
        <p class="weui-toast__content">{{perstips}}</p>
      </div>
    </div>
    <!-- 加载中 -->
    <PageLong :style="'display:' + perslong"></PageLong>
  </div>
</template>

<script>
import "./obraojs/rem"
export default {
  data () {
    return{
      loginID: '',
      persfail: 'none',
      perstips: '',
      persbant: '',
      perslong: 'block'
    }
  },
  created () {
    // 从缓存里获取token
    this.loginID = localStorage.getItem("usertoken");
    this.$axios.post('wx/findByUserNameAndMessage',this.$qs.stringify({
      ID: this.loginID
    }),{headers:{'Content-Type':'application/x-www-form-urlencoded'}})
    .then(res => {
      this.perslong = 'none';
      this.persbant = res.data.userX.USERNAME;
    })
    .catch(() => {
      console.log('获取失败');
    })
  },
  mounted () {

  },
  methods: {
    
  }
}
</script>

<style scoped>
  @import "obraocs/PersCent.css";
</style>